export default "/images/vendor/flag-icon-css/flags/1x1/gb-nir.svg?4e99cb8a463bcacc8f9129313678a2a2";